import { createElement, type ComponentType } from 'react';
import type { DrawerRoute } from '../ui/Shell';
import { Overview } from './Overview';
import { Engines } from './Engines';
import { Voices } from './Voices';
import { ApiApp } from './ApiApp';
import { Releases } from './Releases';
import { ClientVersions } from './ClientVersions';
import { Data } from './Data';
import { Jobs } from './Jobs';
import { Customers } from './Customers';
import { Billing } from './Billing';
import { Costs } from './Costs';
import { Storage } from './Storage';
import { Analytics } from './Analytics';
import { Audit } from './Audit';
import { Ask } from './Ask';
import { Articles } from './Articles';
import { Settings } from './Settings';
import { Simulator } from './Simulator';
import { GpuPool } from './GpuPool';
import { GpuTypes } from './GpuTypes';
import { Support } from './Support';
import { Notifications } from './Notifications';
import { BroadcastDrawer } from './BroadcastDrawer';
import { TranscriptionDrawer } from './TranscriptionDrawer';
import { RecordingDrawer } from './RecordingDrawer';
import { MachineDrawer, type AppKey } from './machines';
import { UsageDrawer } from './UsageDrawer';
import { CustomerDrawer, isCustomerTab } from './CustomerDrawer';

export const SCREEN_COMPONENTS: Record<string, ComponentType> = {
  overview: Overview,
  notifications: Notifications,
  support: Support,
  engines: Engines,
  voices: Voices,
  api: ApiApp,
  releases: Releases,
  'client-versions': ClientVersions,
  'gpu-pool': GpuPool,
  'gpu-types': GpuTypes,
  simulator: Simulator,
  data: Data,
  jobs: Jobs,
  customers: Customers,
  billing: Billing,
  costs: Costs,
  storage: Storage,
  analytics: Analytics,
  audit: Audit,
  ask: Ask,
  articles: Articles,
  settings: Settings,
};

export const DRAWER_ROUTES: Record<string, DrawerRoute> = {
  bc: (id) => createElement(BroadcastDrawer, { id }),
  tx: (rest) => { const [id, tab] = rest.split(':'); return createElement(TranscriptionDrawer, { id, tab: tab === 'costs' ? 'costs' : 'overview' }); },
  rec: (id) => createElement(RecordingDrawer, { id }),
  machine: (rest) => { const [app, id] = rest.split(':'); return APPS.includes(app as AppKey) && id ? createElement(MachineDrawer, { app: app as AppKey, id }) : null; },
  customer: (rest) => { const [id, tab] = rest.split(':'); return id && (!tab || isCustomerTab(tab)) ? createElement(CustomerDrawer, { id, tab: isCustomerTab(tab) ? tab : 'profile' }) : null; },
  user: (id) => createElement(CustomerDrawer, { id, tab: 'profile' }),
  usage: (rest) => { const [kind, id] = rest.split(':'); return (kind === 'key' || kind === 'principal') && id ? createElement(UsageDrawer, { kind, id }) : null; },
  'billing:account': (principalId) => createElement(CustomerDrawer, { id: principalId, tab: 'billing' }),
};
const APPS: AppKey[] = ['engine', 'engine-en', 'api'];
